<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="list-group-item list-group-item-action">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
                <div class="mr-2">{{ version.author }}</div>
                <div v-show="isRelative()" v-bind:title="timestampAbsoluteString()" class="mx-2">
                    {{ timestampString() }}
                </div>
                <div v-show="!isRelative()" class="mx-2">
                    {{ timestampString() }}
                </div>
            </div>
            <button class="btn btn-icon-sm btn-revert btn-menu"
                    title="Revert to this version"
                    v-on:click="revert()">
                <i :class="(isSpinning ? 'visible fa-spin' : 'd-none') + ' fas faw fa-spinner'"
                   role="status"
                   aria-hidden="true"></i>
                <i :class="(isSpinning ? 'd-none' : '') + ' fas fa-undo-alt'"></i>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import {Prop, Component, Vue} from 'vue-facing-decorator';
import {ProjectDto, VersionDto} from '../Teams';
import {timestampAdaptiveString, timestampString} from '../utils/Time';
import {handleXhrError} from '../utils/Ui';
import {updateHistory} from "@/components/ProjectItem.vue";
import {ProjectRevert} from '../ProjectRoutes';

@Component
export default class VersionItem extends Vue {
  private isSpinning = false;

  @Prop()
  private version: VersionDto;

  @Prop()
  private project: ProjectDto;

  @Prop()
  private glasspane: (toggleOn: boolean) => void;

  public timestampAbsoluteString(): string {
    return timestampString(this.version.timestamp);
  }

  public timestampString(): string {
    return timestampAdaptiveString(this.version.timestamp).str;
  }

  public isRelative(): boolean {
    return timestampAdaptiveString(this.version.timestamp).relative;
  }

  public revert() {
    this.isSpinning = true;
    this.glasspane(true);
    ProjectRevert.invoke({ projectRefid: this.project.refid, generation: this.version.number })
        .then(() => updateHistory(this.project.refid))
        .fail((jqXhr) => handleXhrError(jqXhr, 'Failed to revert project version'))
        .always(() => {
          this.isSpinning = false;
          this.glasspane(false);
        });
  }
}
</script>
